export default "__VITE_ASSET__CJXIDooR__"